(() => {
  // Paid-entry release 2026-09-07. No local payment flags or polling.
  document.querySelectorAll('[data-commission-router]').forEach(async (root) => {
    if (root.dataset.commissionReady === 'true') return;
    root.dataset.commissionReady = 'true';
    const studio = root.dataset.commissionRouter === 'studio';
    const payment = root.querySelector('[data-commission-payment]');
    const status = root.querySelector('[data-commission-status]');
    const params = new URLSearchParams(window.location.search);
    const showPayment = () => {
      if (payment) payment.hidden = false;
      if (status) status.hidden = true;
    };
    if (studio && params.get('commission') === 'new') { showPayment(); return; }
    let state = root.querySelector('[data-commission-orders]');
    if (!state) { showPayment(); return; }
    const customerId = state.dataset.customerId;
    const visited = new Set();
    try {
      let selected;
      let fallback;
      while (state) {
        const orders = [...state.querySelectorAll('[data-commission-order]')];
        fallback ||= orders[0];
        selected = params.get('order') && !studio
          ? orders.find(order => order.dataset.id === params.get('order'))
          : orders[0];
        if (selected || !state.dataset.nextUrl) break;
        const next = new URL(state.dataset.nextUrl, window.location.origin);
        if (next.origin !== window.location.origin || visited.has(next.href)) throw new Error('Invalid order pagination');
        visited.add(next.href);
        next.searchParams.set('section_id', root.dataset.sectionId);
        const response = await fetch(next.href, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(10000) });
        if (!response.ok) throw new Error('Order lookup failed');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        state = page.querySelector('[data-commission-orders]');
        if (!state || state.dataset.customerId !== customerId) throw new Error('Customer session changed');
      }
      selected ||= fallback;
      if (!selected) { showPayment(); return; }
      if (studio) {
        const destination = new URL(root.dataset.briefUrl, window.location.origin);
        destination.searchParams.set('order', selected.dataset.id);
        window.location.replace(destination.href);
        return;
      }
      const values = { 'contact[Name]': selected.dataset.customerName, 'contact[email]': selected.dataset.email,
        'contact[Order number]': selected.dataset.name, 'contact[WhatsApp]': selected.dataset.whatsapp };
      Object.entries(values).forEach(([name, value]) => {
        const field = root.querySelector(`[name="${name}"]`);
        if (field && !field.value && value) field.value = value;
      });
    } catch (error) {
      const message = root.querySelector('[data-commission-status-text]');
      if (message) message.textContent = root.dataset.error;
      // Keep payment hidden on lookup failure so a paid buyer is not asked to pay again.
    }
  });

  const forms = document.querySelectorAll('[data-custom-commission-checkout]');

  forms.forEach((form) => {
    if (form.dataset.customCommissionReady === 'true') return;
    form.dataset.customCommissionReady = 'true';

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const button = form.querySelector('[data-custom-commission-submit]');
      const message = form.querySelector('[data-custom-commission-message]');
      const originalLabel = button ? button.textContent : '';

      if (!form.reportValidity()) return;

      if (button) {
        button.disabled = true;
        button.textContent = 'Opening secure checkout…';
      }
      if (message) message.textContent = '';

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });

        if (!response.ok) throw new Error('Unable to add the commission deposit.');

        window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
      } catch (error) {
        if (message) {
          message.textContent = 'We could not open checkout. Please try again or contact HandArtNails Studio.';
        }
        if (button) {
          button.disabled = false;
          button.textContent = originalLabel;
        }
      }
    });
  });
})();
